import React, { useState } from 'react';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase/config';

const MigrationTool = () => {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const runMigration = async () => {
    try {
      setLoading(true);
      setError(null);
      setResult(null);
      
      console.log('Iniciando migración de campo codigo_promo...');
      
      const reservationsRef = collection(db, 'reservations');
      const snapshot = await getDocs(reservationsRef);
      
      let count = 0;
      const promises = [];
      
      snapshot.forEach((document) => {
        const data = document.data();
        
        // Solo actualizar si no tiene el campo codigo_promo
        if (!('codigo_promo' in data)) {
          promises.push(
            updateDoc(doc(db, 'reservations', document.id), {
              codigo_promo: null
            })
          );
          count++;
        }
      });
      
      await Promise.all(promises);
      
      setResult(`✅ Migración completada. ${count} reservas actualizadas.`);
      console.log(`Migración completada. ${count} reservas actualizadas.`);
      
    } catch (err) {
      console.error('Error en la migración:', err);
      setError(`❌ Error: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-lg shadow-md">
      <h2 className="text-xl font-bold mb-4">Herramienta de Migración</h2>
      <p className="text-gray-600 mb-4">
        Añadir campo 'codigo_promo' a todas las reservas existentes
      </p>
      
      <button
        onClick={runMigration}
        disabled={loading}
        className={`w-full py-2 px-4 rounded ${
          loading 
            ? 'bg-gray-400 cursor-not-allowed' 
            : 'bg-blue-500 hover:bg-blue-600 text-white'
        }`}
      >
        {loading ? 'Migrando...' : 'Ejecutar Migración'}
      </button>
      
      {result && (
        <div className="mt-4 p-3 bg-green-100 text-green-800 rounded">
          {result}
        </div>
      )}
      
      {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-800 rounded">
          {error}
        </div>
      )}
    </div>
  );
};

export default MigrationTool;